export default "__VITE_ASSET__CHO$_dxS__"